<div
  class="comment-item"
  [class.pinned]="comment.is_pinned && !isDeletedPlaceholder()"
  [class.is-reply]="isReply()"
  [class.comment-item--deleted]="isDeletedPlaceholder()">
  <!-- Pinned indicator -->
  <div class="pinned-badge" *ngIf="comment.is_pinned && !isDeletedPlaceholder()">
    <i class="pi pi-thumbtack"></i> Pinned
  </div>

  <div class="reply-context" *ngIf="isReply() && parentComment">
    <i class="pi pi-reply reply-context-icon" aria-hidden="true"></i>
    <div class="reply-context-body">
      <span class="reply-context-label">
        Reply to <strong>{{ parentComment.is_deleted ? 'deleted comment' : getReplyToName() }}</strong>
      </span>
      <span
        class="reply-context-preview"
        [class.reply-context-preview--deleted]="parentComment.is_deleted"
        *ngIf="getParentCommentPreview()">{{ getParentCommentPreview() }}</span>
    </div>
  </div>

  <div class="comment-deleted-placeholder" *ngIf="isDeletedPlaceholder()">
    <!-- <i class="pi pi-ban" aria-hidden="true"></i> -->
    <span>Comment Deleted</span>
  </div>

  <ng-container *ngIf="!isDeletedPlaceholder()">
  <!-- Comment header -->
  <div class="comment-header">
    <!-- User avatar -->
    <div class="user-avatar">
      <img *ngIf="getProfilePicUrl()" [src]="getProfilePicUrl()" [alt]="getCreatorName()" />
      <div *ngIf="!getProfilePicUrl()" class="avatar-initials">
        {{ getUserInitials() }}
      </div>
    </div>

    <!-- User info and timestamp -->
    <div class="user-info">
      <div class="user-name">{{ getCreatorName() }}</div>
      <div class="comment-meta">
        <span class="timestamp">{{ getTimeAgo() }}</span>
        <span class="edited-indicator" *ngIf="comment.updated_at"> · Edited</span>
        <span class="internal-badge" *ngIf="comment.is_internal_only">
          <i class="pi pi-lock"></i> Internal
        </span>
      </div>
    </div>

    <!-- Action buttons -->
    <!-- <div class="comment-actions" *ngIf="!isEditing">
      <button 
        *ngIf="isAdmin"
        pButton 
        type="button"
        icon="pi pi-thumbtack" 
        class="p-button-text p-button-sm"
        [class.active-pin]="comment.is_pinned"
        (click)="togglePin()"
        [pTooltip]="comment.is_pinned ? 'Unpin' : 'Pin'"
        tooltipPosition="top">
      </button>
      
      <button 
        pButton 
        type="button"
        icon="pi pi-reply" 
        class="p-button-text p-button-sm"
        (click)="reply()"
        pTooltip="Reply"
        tooltipPosition="top">
      </button>

      <button 
        *ngIf="canEdit()"
        pButton 
        type="button"
        icon="pi pi-pencil" 
        class="p-button-text p-button-sm"
        (click)="startEdit()"
        pTooltip="Edit"
        tooltipPosition="top">
      </button>

      <button 
        *ngIf="canDelete()"
        pButton 
        type="button"
        icon="pi pi-trash" 
        class="p-button-text p-button-sm p-button-danger"
        (click)="deleteComment()"
        pTooltip="Delete"
        tooltipPosition="top">
      </button>
    </div> -->
  </div>

  <!-- Comment body (view mode) -->
<div class="comment-body" *ngIf="!isEditing">
  <p class="comment-text" [innerHTML]="getFormattedCommentText()"></p>

  <div class="comment-attachments" *ngIf="attachmentRows.length">
    <div class="comment-attachment-item" *ngFor="let row of attachmentRows">
      <div class="comment-attachment-thumb">
        <img
          *ngIf="isImageAttachment(row) && row.url"
          [src]="row.url"
          [alt]="row.file.name"
          class="comment-attachment-thumb-img"
          loading="lazy" />
        <div *ngIf="!isImageAttachment(row) || !row.url" class="comment-attachment-thumb-doc" [attr.aria-label]="row.file.name">
          <i class="pi pi-file"></i>
          <span class="comment-attachment-thumb-ext">{{ getFileExtension(row.file.name) }}</span>
        </div>
        <div class="comment-attachment-thumb-overlay">
          <button
            type="button"
            pButton
            icon="pi pi-eye"
            class="p-button-rounded p-button-text comment-attachment-action-btn"
            [disabled]="!row.url"
            (click)="openAttachmentPreview(row)"
            pTooltip="Preview"
            tooltipPosition="top">
          </button>
          <button
            type="button"
            pButton
            icon="pi pi-external-link"
            class="p-button-rounded p-button-text comment-attachment-action-btn"
            [disabled]="!row.url"
            (click)="openAttachmentInNewTab(row)"
            pTooltip="Open in new tab"
            tooltipPosition="top">
          </button>
        </div>
      </div>
      <span
        class="comment-attachment-name"
        [pTooltip]="row.file.name"
        tooltipPosition="bottom">{{ row.file.name }}</span>
    </div>
  </div>

  <div class="comment-attachments-loading" *ngIf="loadingAttachments">
    <span>Loading attachments…</span>
  </div>

<div class="comment-footer" *ngIf="!isEditing">

  <!-- Row 1: Actions -->
<div class="footer-actions">

  <i class="pi pi-reply action-icon" (click)="reply()" pTooltip="Reply" tooltipPosition="bottom"></i>

  <i 
    *ngIf="isAdmin"
    class="pi pi-thumbtack action-icon"
    [class.active-pin]="comment.is_pinned"
    (click)="togglePin()"
    pTooltip="Pin/Unpin" tooltipPosition="bottom">
  </i>

  <i 
    *ngIf="canEdit()"
    class="far fa-edit action-icon"
    (click)="startEdit()"
    pTooltip="Edit" tooltipPosition="bottom">
  </i>

    <!-- <i class="pi pi-plus add-reaction-icon" (click)="reactionPicker.toggle($event)" pTooltip="Add Reaction"
      tooltipPosition="bottom">
    </i> -->

  <i 
    *ngIf="canDelete()"
    class="pi pi-trash action-icon delete"
    (click)="deleteComment()"
    pTooltip="Delete" tooltipPosition="bottom">
  </i>

</div>

  <!-- Row 2: Reactions -->
  <div class="reaction-chips" *ngIf="getReactionSummary()?.length">

    <div
      *ngFor="let reaction of getReactionSummary()"
      class="reaction-chip"
      [class.user-reacted]="reaction.userReacted"
      (click)="toggleReaction(reaction.type)"
    >
      <i class="emoji">{{ reaction.emoji }}</i>
      <span>{{ reaction.count }}</span>
    </div>

  </div>

</div>
</div>

  <!-- Reaction picker overlay -->
  <p-overlayPanel *ngIf="!isDeletedPlaceholder()" #reactionPicker [dismissable]="true" [showCloseIcon]="false">
    <ng-template pTemplate="content">
      <div class="reaction-picker">
        <button
          *ngFor="let reaction of availableReactions"
          pButton
          type="button"
          class="p-button-text reaction-option"
          (click)="toggleReaction(reaction.type, reactionPicker)"
          [pTooltip]="reaction.label"
          tooltipPosition="top">
          <i class="emoji">{{ reaction.emoji }}</i>
        </button>
      </div>
    </ng-template>
  </p-overlayPanel>

  <!-- Comment body (edit mode) -->
  <div class="comment-edit" *ngIf="isEditing">
    <div class="composer-integrated" [class.has-attachments]="editAttachments.length">
      <p-editor
        [(ngModel)]="editText"
        [modules]="editorModules"
        [style]="{ height: '140px' }"
        placeholder="Edit your comment..."
        (onTextChange)="onEditEditorTextChange($event)">
        <ng-template pTemplate="header">

          <span class="ql-formats">
            <select class="ql-header">
              <option value="1"></option>
              <option value="2"></option>
              <option selected></option>
            </select>
          </span>

          <span class="ql-formats">
            <button type="button" class="ql-bold"></button>
            <button type="button" class="ql-italic"></button>
            <button type="button" class="ql-underline"></button>
          </span>
          <span class="ql-formats">
            <button type="button" class="ql-list" value="ordered"></button>
            <button type="button" class="ql-list" value="bullet"></button>
          </span>
          <span class="ql-formats">
            <button type="button" class="custom-attachment-btn">
              <i class="pi pi-paperclip" style="font-size: 13px; color: #494b4e"></i>
            </button>
          </span>
        </ng-template>
      </p-editor>

      <input #editFileInput type="file" multiple hidden (change)="onEditFilesSelected($event)" />

      <div class="composer-attachments composer-attachments-strip" *ngIf="editAttachments.length">
        <div class="composer-attachment-item" *ngFor="let att of editAttachments; let i = index">
          <div class="composer-attachment-thumb">
            <img *ngIf="isImageFile(att.file)" [src]="att.previewUrl" [alt]="att.file.name" class="thumb-image" />
            <div *ngIf="!isImageFile(att.file)" class="thumb-doc" [attr.aria-label]="att.file.name">
              <i class="pi pi-file"></i>
              <span class="thumb-ext">{{ getFileExtension(att.file.name) }}</span>
            </div>
            <div class="thumb-overlay">
              <button
                type="button"
                pButton
                icon="pi pi-eye"
                class="p-button-rounded p-button-text thumb-action-btn"
                (click)="openPendingAttachmentPreview(att)"
                pTooltip="Preview"
                tooltipPosition="top">
              </button>
              <button
                type="button"
                pButton
                icon="pi pi-trash"
                class="p-button-rounded p-button-text thumb-action-btn thumb-remove-btn"
                (click)="removeEditAttachment(i)"
                pTooltip="Remove"
                tooltipPosition="top">
              </button>
            </div>
          </div>
          <span
            class="composer-attachment-name"
            [pTooltip]="att.file.name"
            tooltipPosition="bottom">{{ att.file.name }}</span>
        </div>
      </div>
    </div>

    <div class="edit-actions">
      <button
        pButton
        type="button"
        label="Cancel"
        class="p-button-text cancel-btn"
        (click)="cancelEdit()"
        [disabled]="isSaving">
      </button>
      <button
        pButton
        type="button"
        label="Save"
        class="p-button-rounded comment-edit-save-btn"
        (click)="saveEdit()"
        [disabled]="isSaving || !hasEditEditorText()">
      </button>
    </div>
  </div>
  </ng-container>
</div>

<p-dialog
  header="Preview"
  [(visible)]="previewDialogVisible"
  [closable]="true"
  closeIcon="pi pi-times"
  closeAriaLabel="Close preview"
  [modal]="true"
  [dismissableMask]="true"
  appendTo="body"
  [style]="{ width: 'min(92vw, 720px)' }"
  [contentStyle]="{ overflow: 'auto', maxHeight: '80vh' }"
  (onHide)="onPreviewDialogHide()">
  <ng-container *ngIf="previewRow as pr">
    <img
      *ngIf="isImageAttachment(pr) && pr.url"
      [src]="pr.url"
      [alt]="pr.file.name"
      class="comment-attachment-preview-img" />
    <iframe
      *ngIf="isPdfAttachment(pr) && pr.url"
      [title]="pr.file.name"
      [src]="previewPdfSafe()"
      class="comment-attachment-preview-iframe"></iframe>
    <div
      *ngIf="!pr.url || (!isImageAttachment(pr) && !isPdfAttachment(pr))"
      class="comment-attachment-preview-fallback">
      <i class="pi pi-file comment-attachment-preview-fallback-icon"></i>
      <p class="comment-attachment-preview-name">{{ pr.file.name }}</p>
      <button
        *ngIf="pr.url"
        pButton
        type="button"
        class="p-button-outlined p-button-sm"
        (click)="openAttachmentInNewTab(pr)">
        <span>Open in new tab</span>
      </button>
    </div>
  </ng-container>
  <ng-container *ngIf="pendingPreviewAttachment as pa">
    <img
      *ngIf="isImageFile(pa.file)"
      [src]="pa.previewUrl"
      [alt]="pa.file.name"
      class="comment-attachment-preview-img" />
    <iframe
      *ngIf="isPdfFile(pa.file)"
      [title]="pa.file.name"
      [src]="pendingPreviewPdfSafe()"
      class="comment-attachment-preview-iframe"></iframe>
    <div
      *ngIf="!isImageFile(pa.file) && !isPdfFile(pa.file)"
      class="comment-attachment-preview-fallback">
      <i class="pi pi-file comment-attachment-preview-fallback-icon"></i>
      <p class="comment-attachment-preview-name">{{ pa.file.name }}</p>
      <a
        pButton
        type="button"
        class="p-button-outlined p-button-sm"
        [href]="pa.previewUrl"
        target="_blank"
        rel="noopener noreferrer">
        <span>Open in new tab</span>
      </a>
    </div>
  </ng-container>
</p-dialog>

<p-confirmDialog></p-confirmDialog>
